// PLUGINS IMPORTS //
import React, { ReactNode } from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import InfoSection from "./InfoSection/InfoSection"
import RowList from "../Shared/RowList/RowList"

import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { Themes, GlobalStyles } from "Content/Shared/Styles/Theme"
import { SkillType } from "../Data"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  skill?: SkillType
  children?: ReactNode
}

const BlockItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <Content>
        {props.skill ? (
          <>
            <SectionWrap>
              <InfoSection list={props.skill.list} />
            </SectionWrap>

            <SectionWrap style={styles.tech_wrap}>
              <RowList list={props.skill.technologies} />
            </SectionWrap>
          </>
        ) : (
          <SectionWrap>{props.children}</SectionWrap>
        )}
      </Content>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  margin-bottom: 30px;
`

const Content = styled.div`
  flex-direction: row;
  display: flex;
  color: #e6e6e6;
`

const WRAPPER_PADDING = 15
const SectionWrap = styled.div`
  flex: 1;
  background-color: ${Themes.card.backgroundColor};
  box-shadow: ${Themes.card.boxShadow};
  padding: 0px ${WRAPPER_PADDING}px ${WRAPPER_PADDING * 2}px
    ${WRAPPER_PADDING}px;
  border-radius: ${GlobalStyles.borderRadius}px;
`

const styles = {
  tech_wrap: {
    marginLeft: 15,
  },
}
export default React.memo(BlockItem, memoComparison)
